import { gql } from '@apollo/client';

/**
 * Admin "Check now": finishes whatever an investment's wallet is still waiting on — the ACE
 * credential, and this asset's own registry for a legacy asset — and returns the mint
 * preflight's answer right now.
 */
export const REFRESH_INVESTMENT_COMPLIANCE = gql`
  mutation RefreshInvestmentCompliance($investmentId: String!) {
    refreshInvestmentCompliance(investmentId: $investmentId) {
      statusCode
      message
      error
      compliance {
        ready
        blockedStatus
        reason
        applicable
      }
    }
  }
`;
